import React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  DateInput,
  BooleanInput,
  ImageInput,
  ImageField,
  required,
  maxLength,
} from "react-admin";
import { RichTextInput } from 'ra-input-rich-text';

const ArticleTitle = ({ record }) => {
  return <span>Artículo {record ? `"${record.title}"` : ""}</span>;
};

export const ArticleEdit = (props) => (
  <Edit
    title={<ArticleTitle />}
    {...props}
    transform={(data) => {
      // Función para limpiar valores individuales
      const cleanValue = (value) => {
        if (!value) return null;
        if (value.rawFile instanceof File) return value;
        if (typeof value === "string") return { src: value };
        return value;
      };

      // Asegurarnos que los campos de texto sean string vacío en lugar de null
      const ensureString = (value) => {
        if (value === null || value === undefined) return "";
        return value;
      };

      return {
        ...data,
        title: ensureString(data.title),
        content: ensureString(data.content),
        image: cleanValue(data.image),
      };
    }}
  >
    <SimpleForm redirect="list">
      <TextInput source="id" disabled style={{ width: "50px" }} />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          width: "100%",
        }}
      >
        <TextInput
          source="title"
          label="Título"
          validate={[required(), maxLength(255)]}
          style={{ width: "50%" }}
        />
        <TextInput
          source="slug"
          label="Slug"
          validate={[required(), maxLength(255)]}
          style={{ width: "50%" }}
        />
      </div>
      <RichTextInput
        source="content"
        label="Contenido"
        validate={[required()]}
      />
      <ImageInput
        source="image"
        label="Imagen Principal"
        accept={{
          "image/*": [".png", ".jpg", ".jpeg", ".gif"],
        }}
        placeholder="Haz clic aquí o arrastra y suelta la imagen"
        validate={[required()]}
        options={{
          preventDropOnDocument: true,
          validator: (file) => {
            if (!file.type.startsWith("image/")) {
              return {
                code: "invalid-file-type",
                message: "Solo se permiten imágenes",
              };
            }
            return null;
          },
        }}
        format={(value) => {
          if (typeof value === "string" && value !== "") {
            return { src: value };
          }
          return value;
        }}
      >
        <ImageField source="src" title="title" />
      </ImageInput>
      <DateInput
        source="publishedAt"
        label="Fecha de Publicación"
        validate={[required()]}
        options={{
          locale: "es-ES",
        }}
        style={{ width: "200px" }}
      />
      <BooleanInput source="active" label="Activo" />
    </SimpleForm>
  </Edit>
);
